import devLogger from 'react-utils/devLogger';
const getIconColorForUse = (use, theme) => {
  switch (use) {
    case 'danger':
    case 'default':
      return theme.color['icon-interactive-on-fill-default'];
    case 'longform':
      return theme.color['icon-interactive-default'];
    default:
      {
        /**
         * TODO Ideally we would throw an error here, but for now we will just ignore to prevent errors like:
         * @see https://hubspot.slack.com/archives/C1WG3L3J6/p1757450727687339
         */

        if (process.env.NODE_ENV !== 'production') {
          devLogger.warn({
            message: `Tooltip: Invalid use argument detected: "${use}"`,
            key: 'Tooltip: Invalid use argument',
            url: 'https://github.com/HubSpotEngineering/foundations-components/issues/7475'
          });
        }
        return undefined;
      }
  }
};
export const getTooltipIconStyleOverrides = (use, theme) => {
  return {
    color: getIconColorForUse(use, theme)
  };
};